import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveSubModels, GetSubModels } from './index';

// Api's
import { subModelApi } from '@/main/api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getSubModelsSaga(action: GetSubModels) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      subModelApi.getVehicleSubmodelByGuidCountry,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveSubModels(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveSubModels(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

